import ApiService from './api.service'
import { Error } from './responses/Error';
import { Geoloc } from "@/pitprojekt/models/Geoloc";
import {CurrentUser} from "@/pitprojekt/models/CurrentUser";
import {deserialize} from "serializr";

const GeoIPService = {

    /**
     * Get Geoloc object by IP
     *
     * @returns Geoloc
     * @throws Error
     **/
    getGeolocByIP: async function(ip: string) {
        try {
            const response = await ApiService.get('/api/geoip/get-geoloc-by-ip?ip=' + ip);
            const geoloc:Geoloc = deserialize(Geoloc, response.data);
            return geoloc;
        }
        catch (error) {
            throw Error.build(error);
        }
    },

}

export default GeoIPService

export { GeoIPService }
